import styles from "./styles.module.scss"

export default function Card({ children, padding= 16 }) {
  return <div className={styles.container} style={{padding}}>{children}</div>
}
